<template>
	<div class="municipality-search">
		<template v-if="selectedMunicipality.id === null">
			<div class="form-group">
				<label for="search">
					Municipality
					<span
						role="button"
						:title="'You can search name and state separated with comma, example:black river,wi'"
					>
						ℹ️
					</span>
				</label>
				<input
					type="text"
					class="form-control"
					v-model="search"
					placeholder="type to search for municipality"
				/>
			</div>
			<div class="search-results-container position-relative">
				<div class="search-results position-absolute bg-white rounded shadow-sm" style="z-index:999">
					<template v-if="!loading">
						<template v-if="municipalities.length > 0">
							<template v-for="municipality in municipalities">
								<div
									:key="municipality.id"
									@click="setMunicipality(municipality)"
									class="search-item ps-2 pe-2 py-1 d-flex"
								>
									<span class="me-2 w-50">{{ municipality.full_name }}</span>
									<span class="me-2 w-25">{{ municipality.county }}</span>
									<span class="w-25 text-end pe-2">{{ municipality.state }}</span>
								</div>
							</template>
						</template>
						<template v-if="municipalities.length === 0 && search.length > 3">
							<span class="me-2 ms-2">Municipality not found!</span>
						</template>
					</template>
					<template v-else>
						<div class="d-flex justify-content-center p-2">
							<div class="spinner-border spinner-border-sm" role="status">
								<span class="sr-only">Loading...</span>
							</div>
						</div>
					</template>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="form-group">
				<label for="municipality">Municipality</label>
				<div class="d-flex">
					<h5>{{ selectedMunicipality.name }}</h5>
					<a href="#" @click="changeMunicipality()" class="ms-3">change</a>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import restApi from '../../api/index'
import { handleErrors } from '../../actions/helpers'
export default {
	name: 'MunicipalitySearch',
	props: ['excludeClients', 'selected'],
	data() {
		return {
			loading: false,
			municipalities: [],
			search: '',
			municipalityId: null,
			selectedMunicipality: {
				id: null,
				name: '',
			},
		}
	},
	created() {
		if (this.selected !== null) {
			this.selectedMunicipality = {
				id: this.selected.id,
				name: this.selected.full_name,
			}
		} else {
			this.selectedMunicipality = {
				id: null,
				name: '',
			}
		}
	},
	computed: {
		...mapState(['storageUrl']),
	},
	methods: {
		getMunicipality() {
			this.loading = true
			let clients = this.excludeClients ? 'yes' : ''
			this.params = {
				search: this.search,
				clients: clients,
			}
			restApi
				.get(`/municipalities/search`, { params: this.params })
				.then(({ data }) => {
					this.municipalities = data
					this.loading = false
				})
				.catch(error => {
					this.loading = false
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},
		setMunicipality(municipality) {
			this.selectedMunicipality.id = municipality.id
			this.selectedMunicipality.name = municipality.full_name
			this.municipalities = []
			this.search = ''
			this.$emit('setMunicipality', municipality)
		},
		changeMunicipality() {
			this.selectedMunicipality = {
				id: null,
				name: '',
			}
			this.$emit('setMunicipality', null)
		},
	},
	watch: {
		search: function() {
			if (this.search.length >= 2) {
				if (!this.loading) {
					this.getMunicipality()
				}
			} else {
				this.municipalities = []
			}
		},
	},
}
</script>

<style lang="scss">
.search-results-container {
	.search-results {
		width: 100%;
		.search-item {
			cursor: pointer;
			&:hover {
				background-color: whitesmoke;
				border-radius: 0.5rem;
			}
		}
	}
}
</style>
